export const shiftX = 10;
